module.exports = __webpack_public_path__ + "img/assets/logo-plock.svg";